import { Alert, Steps, Typography } from "antd";
import type { SimpleActiveItem, SimplePipelineStep, SimpleStepState } from "../../hooks/scriptSheet/types";

const { Text } = Typography;

const STEP_ITEMS: Array<{ key: SimplePipelineStep; title: string }> = [
  { key: "images", title: "理解图片" },
  { key: "persona", title: "分析画像" },
  { key: "matching", title: "匹配气氛员" },
  { key: "writeback", title: "回写飞书" },
];

function mapStepStatus(status: SimpleStepState["status"]) {
  switch (status) {
    case "finish":
      return "finish" as const;
    case "process":
    case "retry":
      return "process" as const;
    case "error":
      return "error" as const;
    default:
      return "wait" as const;
  }
}

export interface ScriptFlowProgressProps {
  steps: SimpleStepState[];
  activeItems?: SimpleActiveItem[];
  showWriteback?: boolean;
}

export function ScriptFlowProgress({
  steps,
  activeItems = [],
  showWriteback = false,
}: ScriptFlowProgressProps) {
  const visibleSteps = showWriteback ? STEP_ITEMS : STEP_ITEMS.filter((s) => s.key !== "writeback");
  const currentIndex = steps.findIndex((s) => s.status === "process" || s.status === "retry");
  const items = visibleSteps.map((stepDef) => {
    const state = steps.find((s) => s.step === stepDef.key);
    return {
      title: stepDef.title,
      status: state ? mapStepStatus(state.status) : ("wait" as const),
      description:
        state?.status === "error" || state?.status === "retry"
          ? state.error
            ? state.retryCountdown
              ? `${state.error}（${state.retryCountdown} 秒后重试）`
              : state.error
            : undefined
          : state?.label,
    };
  });

  const displayItems = activeItems.slice(0, 2);

  return (
    <div style={{ marginBottom: 16 }}>
      <Steps
        size="small"
        current={currentIndex >= 0 ? currentIndex : undefined}
        items={items}
        style={{ marginBottom: 16 }}
      />
      {displayItems.length > 0 ? (
        <Alert
          type="info"
          showIcon
          message="正在处理"
          description={
            <div>
              {displayItems.map((item) => (
                <div key={item.key}>
                  <Text>{item.label}</Text>
                </div>
              ))}
            </div>
          }
        />
      ) : null}
    </div>
  );
}
